(function () {
    'use strict';

    angular.module("order")
        .directive('cpPreflightPreview', cpPreflightPreview);

    cpPreflightPreview.$inject = ['$timeout', '$q', '$window', 'orderProductFilesPagesDataSrvc', 'previewLoadingConst', 'qHttp', 'notificationSrvc'];

    function cpPreflightPreview($timeout, $q, $window, orderProductFilesPagesDataSrvc, previewLoadingConst, qHttp, notificationSrvc) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/order/directives/preflight-preview/preflight-preview.html',
            scope: {
                orderProductFile: '=',
                grossSize: '=',
                bleed: '=',
                textMargin: '=',
                productKind: '=',
                techLines: '=',
                onFilePageChange: '&?',
                pagesLoaded: '=',
                loading: '=',
                loadingText: '=',
                readOnly: '=?',
                bookletUv: '=?'
            },
            link: function (scope, element, attrs, controller) {
                var camera, controls, scene, renderer, materials,
                    object, objectBBox, container, carousel,
                    textureCanvas, techLineCanvas, pages;

                if (!scope.readOnly) scope.readOnly = false;
                scope.width = element.find('#preview-wrapper').width();
                scope.indicatorHeight = 40;
                scope.previewWidth = scope.width - scope.indicatorHeight;
                scope.height = 600;
                scope.previewHeight = scope.height - scope.indicatorHeight;
                scope.objectColor = '#ffaa00';
                scope.backgroundColor = '#333333';
                scope.rotateValue = 0;
                scope.zoomValue = 1;
                scope.sizes = null;
                scope.shiftValue = {
                    x: 0,
                    y: 0
                };
                scope.precisionFactor = 1000;
                scope.fileMMSize = scope.grossSize.width;
                scope.fileMMNetSize = scope.grossSize.width - scope.bleed * 2;
                scope.fileGrossHeight = scope.grossSize.height;
                scope.bleedInPx = 0;
                scope.offset = {};
                scope.pxValue = 4;
                scope.scale = 1;
                scope.scaledPxValue = scope.pxValue * scope.precisionFactor * scope.scale;
                scope.canvasWidth = 0;

                scope.zoomedPxValue = scope.pxValue;
                scope.spaceFix = 30;
                scope.rulerFix = scope.spaceFix * scope.precisionFactor * scope.scale;
                scope.fifthSep = 5;
                scope.tenthSep = 10;
                scope.ratio = 0;
                scope.firstPosition = (scope.previewWidth / 2) - scope.spaceFix - scope.indicatorHeight + 1;
                scope.positionFactor = 0;
                scope.targetX = 0;
                scope.dpi = 300;
                scope.inchInMm = 25.4;
                scope.scaleFactor = 1;
                scope.maxSize = 1280;
                scope.previewGrossSize = null;

                scope.isMultiPageFile = checkFileType();
                scope.isHorizontal = false;
                scope.currentPage = 0;
                scope.previousPage = 0;
                scope.currentPageObj = scope.bookletUv ? scope.orderProductFile.cover_pages[0]: scope.orderProductFile.pages[0];
                if (scope.bookletUv) {
                    scope.currentPageMaskObj = scope.orderProductFile.cover_pages[1];
                } else {
                    scope.currentPageMaskObj = scope.productKind === 'uv' ? scope.orderProductFile.pages[1] : null;
                }
                scope.indexFix = scope.productKind === 'uv' ? 2 : 1;
                scope.coverFix = scope.bookletUv ? 2 : 0;
                scope.coverIndexFix = scope.bookletUv ? 2 : 1;
                if (scope.bookletUv) {
                    scope.pageCount = Math.ceil(scope.orderProductFile.pages.length / scope.indexFix) + 4;
                } else {
                    scope.pageCount = Math.ceil(scope.orderProductFile.pages.length / scope.indexFix);
                }

                scope.goToPageNum = {
                    value: null
                };

                scope.uvTechLine = {
                    is_active: null
                };
                scope.bleedTechLine = {
                    is_active: null
                };
                scope.textMarginTechLine = {
                    is_active: null
                };
                scope.cutTechLine = {
                    is_active: null
                };

                for (var i = 0; i < scope.techLines.length; ++i) {
                    if (scope.techLines[i].is_active !== null) {
                        scope.techLines[i].is_active = null;
                    }
                }

                scope.sidebarOpen = true;
                scope.animationInProgress = true;

                scope.getContainerHeight = getContainerHeight;
                scope.acceptPage = acceptPage;
                scope.changePageOnEnter = changePageOnEnter;
                scope.onPageChange = onPageChange;
                scope.resetPageNum = resetPageNum;
                scope.isUv = isUv;
                scope.applyUvMask = applyUvMask;
                scope.hasUvMask = hasUvMask;
                scope.applyTechLine = applyTechLine;
                scope.applyBleedArea = applyBleedArea;
                scope.applyTextMargin = applyTextMargin;
                scope.applyCutLine = applyCutLine;
                scope.hasTechLines = hasTechLines;
                scope.currentPageDisplay = currentPageDisplay;
                scope.pageHasErrors = pageHasErrors;
                scope.pageHasWarnings = pageHasWarnings;
                scope.applyErrors = applyErrors;
                scope.applyWarnings = applyWarnings;
                scope.frontCover = frontCover;
                scope.backCover = backCover;
                scope.isBookletUvPageWithMask = isBookletUvPageWithMask;

                $window.addEventListener( 'resize', onWindowResize, false );

                scope.init = function () {
                    container = angular.element('#preview-wrapper')[0];

                    var FOV = 2 * Math.atan(560 / (2 * 900)) * 180 / Math.PI;

                    camera = new THREE.PerspectiveCamera(FOV, scope.previewWidth / scope.previewHeight, 0.1, 2000);

                    camera.position.x = 0;
                    camera.position.y = 0;
                    camera.position.z = 1000;

                    renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});
                    renderer.setPixelRatio(window.devicePixelRatio);
                    renderer.setSize(scope.previewWidth, scope.previewHeight);
                    renderer.domElement.style.removeProperty('width');
                    renderer.domElement.style.removeProperty('height');
                    container.appendChild(renderer.domElement);

                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.addEventListener('change', scope.render); // remove when using animation loop
                    controls.addEventListener('change', onMove); // remove when using animation loop
                    controls.enableZoom = false;
                    controls.enableRotate = false;
                    controls.mouseButtons = {
                        ORBIT: THREE.MOUSE.RIGHT,
                        ZOOM: THREE.MOUSE.MIDDLE,
                        PAN: THREE.MOUSE.LEFT
                    };

                    scene = new THREE.Scene();
                    materials = [];

                    var URL = $window.URL || $window.webkitURL,
                        loadedTexturesCanvas = [],
                        imageUrls = [],
                        canvasTextures = [];

                    orderProductFilesPagesDataSrvc.getPagePreview({
                        pk: scope.bookletUv ? scope.orderProductFile.cover_pages[0].pk : scope.orderProductFile.pages[0].pk
                    }).$promise.then(
                        function (response) {
                            imageUrls.push({
                                page: scope.bookletUv ? scope.orderProductFile.cover_pages[0].pk : scope.orderProductFile.pages[0].pk,
                                url: URL.createObjectURL(response.data)
                            });
                            createTextureCanvasObjs(loadedTexturesCanvas, imageUrls, URL);

                            $q.all(loadedTexturesCanvas).then(
                                function (patternCanvasTexture) {
                                    var i = 1;
                                    canvasTextures.push(patternCanvasTexture[0]);

                                    if (scope.bookletUv) {
                                        for (i = 1; i < scope.orderProductFile.cover_pages.length / 2; i++) {
                                            canvasTextures.push(prepareTextureCanvasObjs(patternCanvasTexture[0].canvas, i, true));
                                            scope.pagesLoaded++;
                                        }
                                        i = 0;
                                    }

                                    for (; i < scope.orderProductFile.pages.length; i++) {
                                        canvasTextures.push(prepareTextureCanvasObjs(patternCanvasTexture[0].canvas, i, false));
                                        scope.pagesLoaded++;
                                    }

                                    if (scope.bookletUv) {
                                        for (i = scope.orderProductFile.cover_pages.length / 2; i < scope.orderProductFile.cover_pages.length; i++) {
                                            canvasTextures.push(prepareTextureCanvasObjs(patternCanvasTexture[0].canvas, i, true));
                                            scope.pagesLoaded++;
                                        }
                                    }
                                    prepare3dObjects(canvasTextures);
                                    loadOthersImages();
                                }
                            );

                            return imageUrls[0];
                        },
                        function (error) {
                            return error;
                        }
                    );

                }; // @end scope.init

                scope.render = function () {

                    // camera.lookAt(scene.position);

                    renderer.render(scene, camera);

                }; // @end scope.render


                scope.animate = function () {
                    // requestAnimationFrame(scope.animate);
                    controls.update();
                    scope.render();
                    scope.loading = false;
                    scope.animationInProgress = false;
                };

                scope.rotate = function () {

                    rotateObject(scope.rotateValue);
                };

                scope.zoom = function () {
                    scope.zoomValue = parseFloat(scope.zoomValue);
                    if (renderer && scene) {
                        var scaleFactorX = !bleedTechLinesActive() ? scope.initialScale.x : 1,
                            scaleFactorY = !bleedTechLinesActive() ? scope.initialScale.y : 1;
                        object.scale.x = scope.zoomValue * scaleFactorX;
                        object.scale.y = scope.zoomValue * scaleFactorY;

                        var width = objectBBox.max.x - objectBBox.min.x;
                        var height = objectBBox.max.y - objectBBox.min.y;

                        var x = -(scope.previewWidth / 2) + (width * scope.zoomValue * scaleFactorX / 2) + scope.spaceFix;
                        var y = (scope.previewHeight / 2) - (height * scope.zoomValue * scaleFactorY / 2) - scope.spaceFix;

                        object.position.x = x;
                        object.position.y = y;

                        controls.reset();
                        if (scope.isMultiPageFile) {
                            controls.pan(scope.firstPosition, 0);
                            if (scope.currentPage !== 0 && scope.currentPage % 2 !== 0) {
                                controls.pan((scope.sizes.width / scope.positionFactor), 0);
                            }
                        }
                        updateMultiplicitySeparators();
                        updateRuler();
                        renderer.render(scene, camera);
                    }
                };

                scope.changePage = function (pageNum) {
                    if (scope.currentPage === pageNum) {
                        return;
                    }
                    if (pageNum >= 0 && pageNum <= scope.pageCount - 1) {
                        var pageObj = getPageByNum(pageNum);

                        scope.previousPage = scope.currentPage;
                        scope.currentPage = pageNum;
                        scope.currentPageObj = pageObj.page;
                        if ((isUv() || pageObj.isCover) && pageObj.pageMask) {
                            scope.currentPageMaskObj = pageObj.pageMask;
                        } else {
                            scope.currentPageMaskObj = null;
                        }
                        $timeout(function () {
                            var previousPageObj = pageObj.page;
                            if (scope.uvTechLine.is_active !== null) {
                                scope.uvTechLine.is_active = null;
                                applyUvMask(null, scope.previousPage);
                            }
                            if (scope.bleedTechLine.is_active !== null) {
                                scope.bleedTechLine.is_active = null;
                                applyBleedArea(null, scope.previousPage);
                            }
                            if (scope.textMarginTechLine.is_active !== null) {
                                scope.textMarginTechLine.is_active = null;
                                applyTextMargin(null, scope.previousPage);
                            }
                            if (scope.cutTechLine.is_active !== null) {
                                scope.cutTechLine.is_active = null;
                                applyCutLine(null, scope.previousPage);
                            }
                            for (var i = 0; i < scope.techLines.length; ++i) {
                                if (scope.techLines[i].is_active !== null) {
                                    scope.techLines[i].is_active = null;
                                    applyTechLine(scope.techLines[i], scope.previousPage, i);
                                }
                            }
                            if (pageHasErrors(scope.previousPage)) {
                                if (previousPageObj.errors_active !== null) {
                                    previousPageObj.errors_active = null;
                                    applyErrors(null, scope.previousPage);
                                }
                            }
                            if (pageHasWarnings(scope.previousPage)) {
                                if (previousPageObj.warnings_active !== null) {
                                    previousPageObj.warnings_active = null;
                                    applyWarnings(null, scope.previousPage);
                                }
                            }
                        }, 0);
                        if (scope.isMultiPageFile) {
                            updateScene();
                            carousel.slick('slickGoTo', scope.currentPage, true);
                        }
                    }
                };

                scope.isFirstPage = function () {
                    return scope.currentPage === 0;
                };

                scope.isLastPage = function () {
                    return scope.currentPage === (scope.pageCount - 1);
                };

                scope.init();

                if (scope.isMultiPageFile) {
                    $timeout(function () {
                        carousel = element.find('#carousel').slick({
                            dots: false,
                            arrows: false,
                            variableWidth: true,
                            centerMode: true,
                            centerPadding: '0',
                            infinite: false,
                            draggable: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        })
                    }, 150);
                }

                function getPageByNum(pageNum) {
                    var currPageNum,
                        currPageMaskNum,
                        pages,
                        isCover;

                    if (scope.bookletUv && (pageNum < scope.coverFix || pageNum >= scope.orderProductFile.pages.length + scope.coverFix)) {
                        if (pageNum < scope.coverFix) {
                            currPageNum = pageNum * scope.coverIndexFix;
                            currPageMaskNum = pageNum * scope.coverIndexFix + 1;
                        } else {
                            currPageNum = (pageNum - scope.orderProductFile.pages.length - scope.coverFix) * scope.coverIndexFix + (scope.orderProductFile.cover_pages.length / 2);
                            currPageMaskNum = currPageNum + 1;
                        }
                        pages = scope.orderProductFile.cover_pages;
                        isCover = true;
                    } else {
                        currPageNum = pageNum * scope.indexFix - scope.coverFix;
                        currPageMaskNum = pageNum * scope.indexFix - scope.coverFix + 1;
                        pages = scope.orderProductFile.pages;
                        isCover = false;
                    }

                    return {
                        page: pages[currPageNum],
                        pageMask: pages[currPageMaskNum],
                        isCover: isCover
                    }
                }

                function getPageTextureIndex(pageNum) {
                    var pageIndex;
                    if (scope.bookletUv && (pageNum < scope.coverFix || pageNum >= scope.orderProductFile.pages.length + scope.coverFix)) {
                        if (pageNum < scope.coverFix) {
                            pageIndex = pageNum * scope.coverIndexFix;
                        } else {
                            pageIndex = (pageNum - scope.orderProductFile.pages.length - scope.coverFix) * scope.coverIndexFix + scope.orderProductFile.pages.length + (scope.orderProductFile.cover_pages.length / 2);
                        }
                    } else {
                        pageIndex = (pageNum * scope.indexFix - scope.coverFix) + (scope.orderProductFile.cover_pages.length / 2);
                    }

                    return pageIndex;
                }

                function onWindowResize() {
                    scope.width = element.find('#preview-wrapper').width();
                    scope.previewWidth = scope.width - scope.indicatorHeight;
                    scope.previewHeight = scope.height - scope.indicatorHeight;

                    camera.aspect = scope.previewWidth / scope.previewHeight;
                    camera.updateProjectionMatrix();
                    renderer.setSize( scope.previewWidth, scope.previewHeight );

                    if (scope.bleed > 0) {
                        resetGeometriesSizes();
                    }

                    controls.reset();
                    if (scope.isMultiPageFile) {
                        controls.pan(scope.firstPosition, 0);
                        if (scope.currentPage !== 0 && scope.currentPage % 2 !== 0) {
                            controls.pan((scope.sizes.width / scope.positionFactor), 0);
                        }
                    }

                    scope.animate();
                }

                function prepare3dObjects(canvasTextures) {
                    textureCanvas = [];
                    angular.forEach(canvasTextures, function (canvasTexture) {
                        if (canvasTexture.texture) {
                            canvasTexture.texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
                            canvasTexture.texture.magFilter = THREE.NearestFilter;
                            canvasTexture.texture.minFilter = THREE.NearestFilter;
                            canvasTexture.texture.needsUpdate = true;
                            materials.push(
                                new THREE.MeshBasicMaterial({
                                    map: canvasTexture.texture,
                                    side: THREE.FrontSide,
                                    transparent: true
                                })
                            );
                        }
                        textureCanvas.push(canvasTexture);
                    });

                    scope.bleedInPx = Math.ceil(scope.bleed * Math.round(((scope.dpi / scope.inchInMm) * materials[0].map.image.width / scope.previewGrossSize.width) * scope.precisionFactor) / scope.precisionFactor);
                    scope.sizes = fixSize(materials[0].map);

                    object = new THREE.Group();
                    var materialsForPages = [],
                        i;

                    for (i = 0; i < materials.length; i += 2) {
                        materialsForPages.push(materials.slice(i, i + 2));
                    }

                    materialsForPages = materialsForPages.reverse();

                    pages = [];
                    for (i = 0; i < materialsForPages.length; i++) {
                        var page = new THREE.Object3D();
                        var g1 = new THREE.PlaneGeometry(scope.sizes.width, scope.sizes.height),
                            m1 = new THREE.Mesh(g1, materialsForPages[i][0]),
                            eg1 = new THREE.EdgesGeometry(m1.geometry),
                            em1 = new THREE.LineBasicMaterial({color: 0x000000, linewidth: 1}),
                            wf1 = new THREE.LineSegments(eg1, em1);
                        m1.add(wf1);

                        page.add(m1);
                        if (materialsForPages[i][1]) {
                            var g2 = new THREE.PlaneGeometry(scope.sizes.width, scope.sizes.height),
                                m2 = new THREE.Mesh(g2, materialsForPages[i][1]),
                                eg2 = new THREE.EdgesGeometry(m2.geometry),
                                em2 = new THREE.LineBasicMaterial({color: 0x000000, linewidth: 1}),
                                wf2 = new THREE.LineSegments(eg2, em2);
                            m2.add(wf2);
                            m2.rotation.y = Math.PI;
                            page.add(m2);
                        }
                        page.renderOrder = object.children.length;
                        pages.push(page);
                    }

                    for (var k = pages.length - 1; k >= 0; k--) {
                        object.add(pages[k]);
                    }

                    objectBBox = new THREE.Box3().setFromObject(object);

                    scope.pxValue = Math.round((scope.dpi / scope.inchInMm) * scope.scaleFactor * scope.precisionFactor) / scope.precisionFactor;
                    scope.scale = scope.zoomValue * 10;
                    scope.scaledPxValue = scope.pxValue * scope.precisionFactor * scope.scale;
                    scope.rulerFix = scope.spaceFix * scope.precisionFactor * scope.scale;

                    object.position.x = -(scope.previewWidth / 2 - scope.sizes.width / 2) + scope.spaceFix;
                    object.position.y = scope.previewHeight / 2 - scope.sizes.height / 2 - scope.spaceFix;
                    object.position.z = 100;

                    scene.add(object);

                    if (scope.bleed > 0) {
                        resetGeometriesSizes();
                        fixBleedArea();
                    }

                    if (scope.isMultiPageFile) {
                        controls.pan(scope.firstPosition, 0);
                        scope.targetX = controls.target.x;
                        scope.positionFactor = (controls.target.x / scope.firstPosition) - 0.02;
                    } else {
                        controls.pan(1, 0);
                        // controls.pan(0, 0);
                    }

                    scope.initialScale = {
                        x: object.scale.x,
                        y: object.scale.y
                    };

                    updateRuler();
                    onWindowResize();

                    var loadedTechLinesCanvas = [];
                    angular.forEach(scope.techLines, function (techLine) {
                        var canvas = angular.element('<canvas></canvas>')[0],
                            ctx = canvas.getContext('2d');
                        loadedTechLinesCanvas.push($q(function (resolve, reject) {
                            var img = new Image();
                            img.crossOrigin = "Anonymous";
                            img.onload = function () {
                                canvas.width = textureCanvas[0].canvas.width;
                                canvas.height = textureCanvas[0].canvas.height;
                                var scaleX = canvas.width / img.width,
                                    scaleY = canvas.height / img.height;
                                ctx.scale(-scaleX, scaleY);
                                ctx.drawImage(
                                    img,
                                    -img.width, 0
                                );
                                var flippedData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                ctx.clearRect(0, 0, canvas.width, canvas.height);
                                ctx.scale(scaleX, scaleY);
                                ctx.drawImage(
                                    img,
                                    0, 0
                                );
                                var originData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                resolve({
                                    canvas: canvas,
                                    ctx: ctx,
                                    originData: originData,
                                    flippedData: flippedData
                                });
                            };
                            img.onerror = function (xhr) {
                                reject(new Error(xhr + 'An error occurred while loading'));
                            };
                            img.src = techLine.tech_line_object.image_url;
                        }));
                    });

                    $q.all(loadedTechLinesCanvas).then(
                        function (canvasTechLines) {
                            techLineCanvas = canvasTechLines;
                        }, function(err) {
                            console.log('err: ', err)
                        }
                    );

                    scope.animate();

                    if (!scope.isMultiPageFile) {
                        scope.animationInProgress = true;

                        var angle = 0,
                            rotateInterval = setInterval(function () {
                            if (angle < 360) {
                                angle++;
                                rotateObject(angle);
                                scope.$apply();
                            } else {
                                angle = 0;
                                rotateObject(angle);
                                clearInterval(rotateInterval);
                                scope.animationInProgress = false;
                                scope.$apply();
                            }
                        }, 6);
                    }
                }

                function prepareTextureCanvasObjs(patternCanvas, index, isCover) {
                    var canvas = angular.element('<canvas></canvas>')[0],
                        ctx = canvas.getContext('2d');

                    canvas.width = patternCanvas.width;
                    canvas.height = patternCanvas.height;

                    var originData = ctx.getImageData(0, 0, canvas.width, canvas.height),
                        textString = previewLoadingConst.texturesLoadingText,
                        textWidth = ctx.measureText(textString).width;

                    ctx.font = "50px Arial";
                    ctx.fillStyle = "white";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.fillStyle = "#9f826f";
                    ctx.textBaseline = 'middle';
                    ctx.textAlign = "center";
                    ctx.fillText(textString , canvas.width / 2, canvas.height / 2);

                    var data = {
                        canvas: canvas,
                        ctx: ctx,
                        originData: originData,
                        imgLoaded: false
                    },
                    indexFix = isCover ? 2 : scope.indexFix;

                    if (index % indexFix === 0) {
                        data['texture'] = new THREE.Texture(canvas)
                    }

                    return data;
                }
                
                function loadOthersImages() {
                    var i = 1,
                        j = 1;
                    scope.pagesLoaded = 1;

                    if (scope.bookletUv) {
                        for (i = 1; i < scope.orderProductFile.cover_pages.length / 2; i++) {
                            loadImage(i, scope.orderProductFile.cover_pages[i].pk, true);
                        }
                        j = 0;
                    }

                    for (; j < scope.orderProductFile.pages.length; j++, i++) {
                        loadImage(i, scope.orderProductFile.pages[j].pk, false);
                    }

                    if (scope.bookletUv) {
                        for (j = scope.orderProductFile.cover_pages.length / 2; j < scope.orderProductFile.cover_pages.length; j++, i++) {
                            loadImage(i, scope.orderProductFile.cover_pages[j].pk, true);
                        }
                    }
                }

                function loadImage(i, pk, isCover) {
                    var indexFix = isCover ? 2 : scope.indexFix;
                    orderProductFilesPagesDataSrvc.getPagePreview({
                        pk: pk
                    }).$promise.then(
                        (function (i) {
                            return function (response) {
                                var img = new Image(),
                                    imgUrl = URL.createObjectURL(response.data);
                                img.crossOrigin = "Anonymous";
                                img.onload = function () {
                                    textureCanvas[i].ctx.drawImage(img, 0, 0, textureCanvas[i].canvas.width, textureCanvas[i].canvas.height, 0, 0, textureCanvas[i].canvas.width, textureCanvas[i].canvas.height);
                                    textureCanvas[i].originData = textureCanvas[i].ctx.getImageData(0, 0, textureCanvas[i].canvas.width, textureCanvas[i].canvas.height);
                                    if (i % indexFix === 0) {
                                        textureCanvas[i].texture.needsUpdate = true;
                                    }
                                    URL.revokeObjectURL(imgUrl);
                                    scope.pagesLoaded++;
                                    scope.render();
                                };
                                img.onerror = function (xhr) {
                                    console.log(xhr + 'An error occurred while loading');
                                };
                                img.src = imgUrl;
                            }
                        } (i)),
                        function (error) {
                            return error;
                        }
                    )
                }

                function createTextureCanvasObjs(loadedTexturesCanvas, imageUrls, URL) {
                    angular.forEach(imageUrls, function (imageUrl, index) {
                        var canvas = angular.element('<canvas></canvas>')[0],
                            ctx = canvas.getContext('2d');
                        loadedTexturesCanvas.push($q(function (resolve, reject) {
                            var img = new Image();
                            img.crossOrigin = "Anonymous";
                            img.onload = function () {
                                var height, width, size;
                                if (img.height > img.width) {
                                    width = scope.grossSize.preview_height > scope.grossSize.preview_width ? scope.grossSize.preview_width : scope.grossSize.preview_height;
                                    height = scope.grossSize.preview_height > scope.grossSize.preview_width ? scope.grossSize.preview_height : scope.grossSize.preview_width;
                                } else {
                                    width = scope.grossSize.preview_width > scope.grossSize.preview_height ? scope.grossSize.preview_width : scope.grossSize.preview_height;
                                    height = scope.grossSize.preview_width > scope.grossSize.preview_height ? scope.grossSize.preview_height : scope.grossSize.preview_width;
                                }
                                if (scope.previewGrossSize === null) {
                                    scope.previewGrossSize = {
                                        width: width,
                                        height: height,
                                        imgWidth: img.width,
                                        imgHeight: img.height
                                    }
                                }
                                size = resize(width, height);

                                canvas.width = size.width;
                                canvas.height = size.height;
                                ctx.drawImage(img, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
                                var originData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                var data = {
                                    canvas: canvas,
                                    ctx: ctx,
                                    originData: originData
                                };
                                if (index % scope.indexFix === 0) {
                                    data['texture'] = new THREE.Texture(canvas)
                                }
                                resolve(data);
                                URL.revokeObjectURL(imageUrl.url);
                                scope.pagesLoaded++;
                            };
                            img.onerror = function (xhr) {
                                reject(new Error(xhr + 'An error occurred while loading'));
                            };
                            img.src = imageUrl.url;
                        }));
                    });
                }

                function resize(width, height) {
                    var ratio = 0;

                    if(width > scope.maxSize) {
                        ratio = scope.maxSize / width;
                        height = height * ratio;
                        width = width * ratio;
                    }

                    if(height > scope.maxSize) {
                        ratio = scope.maxSize / height;
                        width = width * ratio;
                        height = height * ratio;
                    }

                    return { width: width, height: height }
                }

                function fixSize(texture) {
                    var width = texture.image.width,
                        height = texture.image.height;
                    var sizeFix = 0.99;

                    function fixHeight() {
                        // Check if current height is larger than max
                        if (height > (scope.previewHeight - scope.spaceFix) * sizeFix) {
                            scope.ratio = ((scope.previewHeight - scope.spaceFix) * sizeFix) / height; // get ratio for scaling image
                            width = Math.round(width * scope.ratio);    // Reset width to match scaled image
                            height = Math.round(height * scope.ratio);    // Reset height to match scaled image
                        }
                    }

                    function fixWidth() {
                        // Check if the current width is larger than the max
                        var divisor = scope.isHorizontal && scope.isMultiPageFile ? 0.495 : 1;
                        if (width > (scope.previewWidth - scope.spaceFix) * sizeFix * divisor) {
                            scope.ratio = ((scope.previewWidth - scope.spaceFix) * sizeFix * divisor) / width;   // get ratio for scaling image
                            height = Math.round(height * scope.ratio);    // Reset height to match scaled image
                            width = Math.round(width * scope.ratio);    // Reset width to match scaled image
                        }
                    }

                    if (height > width) {
                        scope.isHorizontal = false;
                        fixHeight();
                        fixWidth();
                        scope.fileMMSize = scope.grossSize.height > scope.grossSize.width ? scope.grossSize.width : scope.grossSize.height;
                        scope.fileGrossHeight = scope.grossSize.height > scope.grossSize.width ? scope.grossSize.height : scope.grossSize.width;
                        scope.scaleFactor = width / (scope.grossSize.preview_height > scope.grossSize.preview_width ? scope.grossSize.preview_width : scope.grossSize.preview_height);
                    } else {
                        scope.isHorizontal = true;
                        fixWidth();
                        fixHeight();
                        scope.fileMMSize = scope.grossSize.width > scope.grossSize.height ? scope.grossSize.width : scope.grossSize.height;
                        scope.fileGrossHeight = scope.grossSize.width > scope.grossSize.height ? scope.grossSize.height : scope.grossSize.width;
                        scope.scaleFactor = width / (scope.grossSize.preview_width > scope.grossSize.preview_height ? scope.grossSize.preview_width : scope.grossSize.preview_height);
                    }
                    scope.fileMMNetSize = scope.fileMMSize - scope.bleed * 2;

                    updateMultiplicitySeparators();

                    return {width: width, height: height};
                }

                function updateRuler() {
                    $timeout(function () {
                        var rulerCanvas = angular.element("#ruler_canvas")[0];

                        var rulerCtx = rulerCanvas.getContext('2d');
                        rulerCtx.clearRect(0, 0, rulerCanvas.width, rulerCanvas.height);
                        rulerCtx.fillStyle = rulerCtx.strokeStyle = '#a1826e';

                        rulerCtx.beginPath();
                        scope.scale = scope.zoomValue * 10;
                        scope.scaledPxValue = scope.pxValue * scope.precisionFactor * scope.scale;
                        scope.canvasWidth = rulerCanvas.width * 10 * scope.precisionFactor;
                        var sepFix = scope.tenthSep / 10;

                        scope.zoomedPxValue = scope.pxValue * scope.zoomValue * sepFix;
                        for (var i = 0; i < scope.canvasWidth; i += (scope.scaledPxValue * sepFix)) {
                            var scaledValue = (i + scope.rulerFix) / 10 / scope.precisionFactor;
                            var tenthValue = scope.scaledPxValue * scope.tenthSep;
                            var fifthValue = scope.scaledPxValue * scope.fifthSep;

                            var shiftedPositionX = i + (scope.scaledPxValue * sepFix * Math.ceil((scope.shiftValue.x) / scope.zoomedPxValue));
                            var shiftedPositionY = i - (scope.scaledPxValue * sepFix * Math.floor((scope.shiftValue.y) / scope.zoomedPxValue));

                            var shiftX = (shiftedPositionX % tenthValue === 0) ? 10 : (shiftedPositionX % fifthValue === 0) ? 15 : 25;
                            var shiftY = (shiftedPositionY % tenthValue === 0) ? 10 : (shiftedPositionY % fifthValue === 0) ? 15 : 25;

                            if (shiftedPositionX % tenthValue === 0) {
                                var labelX = String(shiftedPositionX / scope.scaledPxValue);
                                var fixX = 3 + ((labelX.length - 1) * 2);
                                rulerCtx.fillText(labelX, scaledValue + scope.indicatorHeight - fixX, 8);

                            }

                            if (shiftedPositionY % tenthValue === 0) {
                                var labelY = String(shiftedPositionY / scope.scaledPxValue);
                                var fixY = 3 + ((labelY.length - 1) * 2);

                                rulerCtx.save();
                                rulerCtx.translate(8, scaledValue + scope.indicatorHeight + fixY);
                                rulerCtx.rotate(-90 * Math.PI / 180);
                                rulerCtx.fillText(labelY, 0, 0);
                                rulerCtx.restore();
                            }

                            rulerCtx.moveTo(scaledValue + scope.indicatorHeight, shiftX);
                            rulerCtx.lineTo(scaledValue + scope.indicatorHeight, scope.indicatorHeight);

                            rulerCtx.moveTo(shiftY, scaledValue + scope.indicatorHeight);
                            rulerCtx.lineTo(scope.indicatorHeight, scaledValue + scope.indicatorHeight);
                        }
                        rulerCtx.stroke();
                    });
                }

                function onMove() {
                    scope.shiftValue.x = controls.target.x;
                    scope.shiftValue.y = controls.target.y;
                    updateRuler();
                }

                function getContainerHeight() {
                    var previewSlider = element.find("#preview-slider")[0],
                        acceptBlock = element.find("#preview-accept-block")[0],
                        errorsBlock = element.find("#preview-errors-block")[0],
                        techLinesBlock = element.find("#preview-tech-lines")[0],
                        controlsHeight = element.find("#preview-controls")[0].offsetHeight,
                        sliderHeight = previewSlider ? previewSlider.offsetHeight : 0,
                        acceptBlockHeight = acceptBlock ? acceptBlock.offsetHeight : 0,
                        errorsBlockHeight = errorsBlock ? errorsBlock.offsetHeight : 0,
                        techLinesHeight = techLinesBlock ? techLinesBlock.offsetHeight : 0;
                    return scope.height + controlsHeight + sliderHeight + acceptBlockHeight + errorsBlockHeight + techLinesHeight;
                }

                function roundUpToTen(n) {
                    return (Math.ceil(n) % 10 === 0) ? Math.ceil(n) : Math.round((n + 10 / 2) / 10) * 10;
                }

                function updateMultiplicitySeparators() {
                    scope.tenthSep = roundUpToTen(scope.fileMMSize / 10);
                    scope.tenthSep -= (scope.zoomValue * scope.tenthSep - scope.tenthSep);
                    scope.tenthSep = roundUpToTen(scope.tenthSep);
                    if (scope.tenthSep < 10) scope.tenthSep = 10;
                    scope.fifthSep = scope.tenthSep / 2;
                }

                function checkFileType() {
                    if (scope.productKind === 'uv') {
                        return scope.orderProductFile.pages.length > 4;
                    } else {
                        return scope.orderProductFile.pages.length > 2;
                    }
                }

                function updateScene() {
                    var i;
                    if (scope.currentPage > scope.previousPage) {
                        for (i = scope.previousPage + 1; i <= scope.currentPage; i++) {
                            updatePage(i);
                        }
                    } else {
                        for (i = scope.previousPage - 1; i >= scope.currentPage; i--) {
                            updatePage(i);
                        }
                    }

                }

                function updatePage(currentPage) {
                    var currentCardIndex = Math.floor(currentPage / 2);
                    var currentPageIndex = currentPage % 2 === 0 ? 0 : 1;

                    object.children[currentCardIndex].visible = true;
                    object.children[currentCardIndex].children[currentPageIndex].material.opacity = 1;
                    if (currentPage % 2 !== 0) {
                        object.children[currentCardIndex].rotation.y = Math.PI;
                        object.children[currentCardIndex].position.set(0, 0, 0);
                        if (object.children[currentCardIndex - 1]) {
                            object.children[currentCardIndex - 1].rotation.set(0, 0, 0);
                            object.children[currentCardIndex - 1].position.set(0, 0, 0);
                            object.children[currentCardIndex - 1].visible = false;
                        }
                        if (object.children[currentCardIndex + 1]) {
                            object.children[currentCardIndex + 1].position.set(scope.sizes.width, 0, 0);
                            object.children[currentCardIndex + 1].children[currentPageIndex - 1].material.opacity = 0.5;
                        }
                        controls.pan((scope.sizes.width / scope.positionFactor), 0);
                    } else {
                        object.children[currentCardIndex].rotation.set(0, 0, 0);
                        object.children[currentCardIndex].position.set(0, 0, 0);
                        if (object.children[currentCardIndex - 1]) {
                            object.children[currentCardIndex - 1].rotation.y = Math.PI;
                            object.children[currentCardIndex - 1].position.set(-scope.sizes.width, 0, 0);
                            object.children[currentCardIndex - 1].visible = true;
                            object.children[currentCardIndex - 1].children[currentPageIndex + 1].material.opacity = 0.5;
                        }
                        if (object.children[currentCardIndex + 1]) {
                            object.children[currentCardIndex + 1].position.set(0, 0, 0);
                        }
                        controls.pan(-(scope.sizes.width / scope.positionFactor), 0);
                    }
                }

                function resetScene() {
                    for (var i = object.children.length - 1; i >= 0; i--) {
                        object.children[i].position.set(0, 0, 0);
                        object.children[i].rotation.set(0, 0, 0);
                        object.children[i].scale.set(1, 1, 1);
                        object.children[i].updateMatrix();
                        object.children[i].applyMatrix(new THREE.Matrix4());
                        if (i % 2 === 0) {
                            object.children[i].rotation.y = Math.PI;
                        }
                    }
                    scope.currentPage = 0;
                }

                function checkAllPagesAccepted() {
                    var accepted = true,
                        i;

                    for (i = 0; i < scope.orderProductFile.cover_pages.length; i += scope.coverIndexFix) {
                        if (!scope.orderProductFile.cover_pages[i].is_accepted) {
                            accepted = false;
                            break;
                        }
                    }

                    if (accepted) {
                        for (i = 0; i < scope.orderProductFile.pages.length; i += scope.indexFix) {
                            if (!scope.orderProductFile.pages[i].is_accepted) {
                                accepted = false;
                                break;
                            }
                        }
                    }
                    return accepted;
                }

                function acceptPage(page) {
                    orderProductFilesPagesDataSrvc.update({pk: page.pk}, {
                        is_accepted: page.is_accepted
                    }).$promise.then(
                        function (response) {
                            page.is_accepted = response[0].is_accepted;
                            scope.orderProductFile.preview_accepted = checkAllPagesAccepted();
                            notificationSrvc.notification("success", "Zaakceptowano strone podglądu");

                            if (typeof scope.onFilePageChange === 'function'){scope.onFilePageChange()}
                        },
                        function (response) {
                            notificationSrvc.notification("error", "ERROR");
                        }
                    )
                }

                function changePageOnEnter($event) {
                    if ($event.which === 13) {
                        scope.changePage(this.goToPageNum.value - 1);
                    }
                }

                function onPageChange() {
                    if (this.goToPageNum.value > scope.pageCount) {
                        this.goToPageNum.value = scope.pageCount;
                    } else if (this.goToPageNum.value < 1) {
                        this.goToPageNum.value = 1;
                    }
                }

                function resetPageNum() {
                    scope.goToPageNum.value = null;
                }

                function isUv() {
                    return scope.productKind === 'uv';
                }

                function applyUvMask(state, currentPage) {
                    var pageTextureIndex = getPageTextureIndex(currentPage),
                        texture = textureCanvas[pageTextureIndex],
                        mask = textureCanvas[pageTextureIndex + 1],
                        maskData = mask.originData,
                        textureUpdatedData;

                    if (maskData) {
                        if (state === null) {
                            textureUpdatedData = texture.originData;
                        } else {
                            var alpha = 200,
                                textureData = texture.ctx.getImageData(0, 0, texture.canvas.width, texture.canvas.height),
                                texturePixels = textureData.data,
                                textureOriginPixels = texture.originData.data,
                                maskPixels = maskData.data,
                                color = [255, 255, 0],
                                i, r, g, b;

                            if (state === true) {
                                for (i = 0; i < maskPixels.length; i += 4) {
                                    r = maskPixels[i];
                                    g = maskPixels[i + 1];
                                    b = maskPixels[i + 2];
                                    if (r < 130 && g < 130 && b < 130) {
                                        updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i);
                                    }
                                }
                            } else {
                                for (i = 0; i < maskPixels.length; i += 4) {
                                    r = maskPixels[i];
                                    g = maskPixels[i + 1];
                                    b = maskPixels[i + 2];
                                    if (r < 130 && g < 130 && b < 130) {
                                        updatePixelReverse(texturePixels, textureOriginPixels, i);
                                    }
                                }
                            }
                            textureUpdatedData = textureData;
                        }
                        texture.ctx.putImageData(textureUpdatedData, 0, 0);
                        texture.texture.needsUpdate = true;
                    }

                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function hasUvMask(page) {
                    if (scope.bookletUv) {
                        return (page < scope.coverFix || page >= scope.orderProductFile.pages.length + scope.coverFix) && isBookletUvPageWithMask(page) && !!(textureCanvas && textureCanvas[getPageTextureIndex(page) + 1]);
                    } else if (scope.isUv()) {
                        return !!(textureCanvas && textureCanvas[getPageTextureIndex(page) + 1]);
                    } else {
                        return false;
                    }
                }

                function isBookletUvPageWithMask(page) {
                    return scope.orderProductFile.cover_file_num_pages !== 0 && scope.orderProductFile.cover_file_num_pages < 8 ? page !== 1 && page !== scope.pageCount - 2 : true;
                }

                function applyTechLine(techLine, currentPage, index) {
                    var texture = textureCanvas[getPageTextureIndex(currentPage)],
                        currentTechLineCanvas = techLineCanvas[index],
                        techLineData = currentPage % 2 === 0 ? currentTechLineCanvas.originData : currentTechLineCanvas.flippedData;

                        applyMask(texture, techLineData, techLine.is_active);
                    if (techLine.is_active === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyBleedArea(state, currentPage) {
                    var pageTextureIndex = getPageTextureIndex(currentPage),
                        texture = textureCanvas[pageTextureIndex],
                        bleedInPx = Math.ceil(scope.bleed * (texture.canvas.width / scope.fileMMSize)),
                        textureUpdatedData;

                    scope.sizes = fixSize(materials[0].map);
                    resetGeometriesSizes();
                    fixBleedArea();
                    updateRuler();

                    if (state === null) {
                        textureUpdatedData = texture.originData;
                    } else {
                        var alpha = 200,
                            textureData = texture.ctx.getImageData(0, 0, texture.canvas.width, texture.canvas.height),
                            texturePixels = textureData.data,
                            textureOriginPixels = texture.originData.data,
                            color = [255, 255, 0],
                            i, mod,
                            topLine = texture.canvas.width * bleedInPx * 4,
                            bottomLine = texturePixels.length - topLine,
                            pixelsRow = texture.canvas.width * 4,
                            fourTimesBleed = bleedInPx * 4;

                        for (i = 0; i < texturePixels.length; i += 4) {
                            mod = i % pixelsRow;
                            if (i <= topLine || i >= bottomLine || mod < fourTimesBleed || mod >= pixelsRow - fourTimesBleed) {
                                if (state) {
                                    updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i);
                                } else {
                                    updatePixelReverse(texturePixels, textureOriginPixels, i);
                                }
                            }
                        }
                        textureUpdatedData = textureData;
                    }
                    texture.ctx.putImageData(textureUpdatedData, 0, 0);
                    texture.texture.needsUpdate = true;
                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyTextMargin(state, currentPage) {
                    var texture = textureCanvas[getPageTextureIndex(currentPage)];

                    applyLineMask(texture, scope.textMargin + scope.bleed, state);
                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyCutLine(state, currentPage) {
                    var texture = textureCanvas[getPageTextureIndex(currentPage)];

                    scope.sizes = fixSize(materials[0].map);
                    resetGeometriesSizes();
                    fixBleedArea();
                    updateRuler();

                    applyLineMask(texture, scope.bleed + 0.25, state);
                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyLineMask(texture, line, state) {
                    var mmInPx = Math.round(texture.canvas.width / scope.fileMMSize),
                        quarterMmInPx = Math.ceil(mmInPx / 4),
                        halfMmInPx = Math.ceil(mmInPx / 2),
                        lineInPx = line * mmInPx,
                        textureUpdatedData;

                    if (state === null) {
                        textureUpdatedData = texture.originData;
                    } else {
                        var alpha = 200,
                            textureData = texture.ctx.getImageData(0, 0, texture.canvas.width, texture.canvas.height),
                            texturePixels = textureData.data,
                            textureOriginPixels = texture.originData.data,
                            color = [255, 255, 0],
                            i, mod,
                            topCheck, bottomCheck, leftCheck, rightCheck, leftRightCornerCheck, topBottomCornerCheck,
                            pixelsRow = texture.canvas.width * 4,
                            topLine = (pixelsRow * lineInPx) - (pixelsRow * quarterMmInPx),
                            topLineWithBorder = topLine + (pixelsRow * halfMmInPx),
                            bottomLine = texturePixels.length - topLine,
                            bottomLineWithBorder = texturePixels.length - topLineWithBorder,
                            leftLine = (lineInPx - quarterMmInPx) * 4,
                            leftLineWithBorder = (lineInPx + quarterMmInPx) * 4,
                            rightLine = pixelsRow - leftLineWithBorder,
                            rightLineWithBorder = pixelsRow - leftLine;

                        for (i = 0; i < texturePixels.length; i += 4) {
                            mod = i % pixelsRow;

                            topCheck = i >= topLine && i < topLineWithBorder;
                            bottomCheck = i >= bottomLineWithBorder && i < bottomLine;
                            leftCheck = mod > leftLine && mod <= leftLineWithBorder;
                            rightCheck = mod >= rightLine && mod < rightLineWithBorder;
                            leftRightCornerCheck = mod > leftLine && mod < rightLineWithBorder;
                            topBottomCornerCheck = i >= topLine && i < bottomLine;

                            if ((topCheck && leftRightCornerCheck) ||
                                (bottomCheck && leftRightCornerCheck) ||
                                (topBottomCornerCheck && leftCheck) ||
                                (topBottomCornerCheck && rightCheck)) {
                                if (state) {
                                    updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i);
                                } else {
                                    updatePixelReverse(texturePixels, textureOriginPixels, i);
                                }
                            }
                        }
                        textureUpdatedData = textureData;
                    }
                    texture.ctx.putImageData(textureUpdatedData, 0, 0);
                    texture.texture.needsUpdate = true;
                }

                function applyMask(texture, maskData, state) {
                    var textureUpdatedData;

                    if (maskData) {
                        if (state === null) {
                            textureUpdatedData = texture.originData;
                        } else {
                            var alpha = 200,
                                textureData = texture.ctx.getImageData(0, 0, texture.canvas.width, texture.canvas.height),
                                texturePixels = textureData.data,
                                textureOriginPixels = texture.originData.data,
                                maskPixels = maskData.data,
                                color = [255, 255, 0],
                                i, a;

                            if (state === true) {
                                for (i = 0; i < maskPixels.length; i += 4) {
                                    a = maskPixels[i + 3];
                                    if (a > 0) {
                                        updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i);
                                    }
                                }
                            } else {
                                for (i = 0; i < maskPixels.length; i += 4) {
                                    a = maskPixels[i + 3];
                                    if (a > 0) {
                                        updatePixelReverse(texturePixels, textureOriginPixels, i);
                                    }
                                }
                            }
                            textureUpdatedData = textureData;
                        }
                        texture.ctx.putImageData(textureUpdatedData, 0, 0);
                        texture.texture.needsUpdate = true;
                    }
                }

                function updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i) {
                    texturePixels[i] = (color[0] * alpha + textureOriginPixels[i] * (255 - alpha)) / 255;
                    texturePixels[i + 1] = (color[1] * alpha + textureOriginPixels[i + 1] * (255 - alpha)) / 255;
                    texturePixels[i + 2] = (color[2] * alpha + textureOriginPixels[i + 2] * (255 - alpha)) / 255;
                }

                function updatePixelReverse(texturePixels, textureOriginPixels, i) {
                    var fix = 0;
                    if (textureOriginPixels[i] < 64 && textureOriginPixels[i + 1] < 64 && textureOriginPixels[i + 2] < 64) {
                        fix = -30;
                    }
                    if ((textureOriginPixels[i] > 240 && textureOriginPixels[i + 1] > 240 && textureOriginPixels[i + 2] > 240)) {
                        fix = 30;
                    }
                    texturePixels[i] = 255 - textureOriginPixels[i] + fix;
                    texturePixels[i + 1] = 255 - textureOriginPixels[i + 1] + fix;
                    texturePixels[i + 2] = 255 - textureOriginPixels[i + 2] + fix;
                }

                function applyActiveTechLines(currentPage) {
                    if (scope.uvTechLine.is_active !== null) {
                        applyUvMask(scope.uvTechLine.is_active, currentPage);
                    }
                    if (scope.bleedTechLine.is_active !== null) {
                        applyBleedArea(scope.bleedTechLine.is_active, currentPage);
                    }
                    if (scope.textMarginTechLine.is_active !== null) {
                        applyTextMargin(scope.textMarginTechLine.is_active, currentPage);
                    }
                    if (scope.cutTechLine.is_active !== null) {
                        applyCutLine(scope.cutTechLine.is_active, currentPage);
                    }
                    for (var i = 0; i < scope.techLines.length; ++i) {
                        if (scope.techLines[i].is_active !== null) {
                            applyTechLine(scope.techLines[i], currentPage, i);
                        }
                    }
                    if (pageHasErrors(scope.currentPage)) {
                        if (scope.currentPageObj.errors_active !== null) {
                            applyErrors(scope.currentPageObj.errors_active, scope.currentPage);
                        }
                    }
                    if (pageHasWarnings(scope.currentPage)) {
                        if (scope.currentPageObj.warnings_active !== null) {
                            applyWarnings(scope.currentPageObj.warnings_active, scope.currentPage);
                        }
                    }
                }

                function hasTechLines() {
                    return scope.techLines.length || isUv() || scope.bleed > 0 || scope.textMargin > 0;
                }

                function currentPageDisplay() {
                    return ' ' + (scope.currentPage + 1) + '/' + scope.pageCount;
                }

                function pageHasErrors(currentPage) {
                    var currentPageObj = getPageByNum(currentPage);
                    if (isUv() || currentPageObj.isCover) {
                        return currentPageObj.page.errors || (currentPageObj.pageMask && currentPageObj.pageMask.errors);
                    } else {
                        return currentPageObj.page.errors
                    }
                }

                function pageHasWarnings(currentPage) {
                    var currentPageObj = getPageByNum(currentPage);
                    if (isUv() || currentPageObj.isCover) {
                        return currentPageObj.page.warnings || (currentPageObj.pageMask && currentPageObj.pageMask.warnings);
                    } else {
                        return currentPageObj.page.warnings
                    }
                }

                function applyErrors(state, currentPage) {
                    var texture = textureCanvas[getPageTextureIndex(currentPage)],
                        currentPageObj = getPageByNum(currentPage);

                    applyExceptions(state, currentPageObj.page.errors, texture, currentPageObj.page.width, currentPageObj.page.height);
                    if (isUv() || currentPageObj.isCover) {
                        var pageMaskObj = currentPageObj.pageMask,
                            maskErrors = pageMaskObj ? pageMaskObj.errors : null;
                        if (maskErrors) {
                            applyExceptions(state, maskErrors, texture, pageMaskObj.width, pageMaskObj.height);
                        }
                    }
                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyWarnings(state, currentPage) {
                    var texture = textureCanvas[getPageTextureIndex(currentPage)],
                        currentPageObj = getPageByNum(currentPage);

                    applyExceptions(state, currentPageObj.page.warnings, texture, currentPageObj.page.width, currentPageObj.page.height);
                    if (isUv() || currentPageObj.isCover) {
                        var pageMaskObj = currentPageObj.pageMask,
                            maskWarnings = pageMaskObj ? pageMaskObj.warnings : null;
                        if (maskWarnings) {
                            applyExceptions(state, maskWarnings, texture, pageMaskObj.width, pageMaskObj.height);
                        }
                    }
                    if (state === null) {
                        applyActiveTechLines(currentPage)
                    }
                    scope.render();
                }

                function applyExceptions(state, exceptions, texture, pageWidth, pageHeight) {
                    var textureUpdatedData;

                    if (exceptions) {
                        if (state === null) {
                            textureUpdatedData = texture.originData;
                        } else {
                            var alpha = 200,
                                textureData = texture.ctx.getImageData(0, 0, texture.canvas.width, texture.canvas.height),
                                texturePixels = textureData.data,
                                textureOriginPixels = texture.originData.data,
                                color = [255, 255, 0],
                                i,
                                pixelsRow = texture.canvas.width * 4,
                                mod,
                                topLine, bottomLine, leftLine, rightLine;

                            angular.forEach(exceptions, function (exception) {
                                angular.forEach(exception.hits, function (hit) {
                                    topLine = Math.round(hit.ury * scope.previewGrossSize.imgHeight / pageHeight) * pixelsRow;
                                    bottomLine = Math.round(hit.lly * scope.previewGrossSize.imgHeight / pageHeight) * pixelsRow;
                                    leftLine = Math.round(hit.llx * scope.previewGrossSize.imgWidth / pageWidth) * 4;
                                    rightLine = Math.round(hit.urx * scope.previewGrossSize.imgWidth / pageWidth) * 4;
                                    for (i = 0; i < texturePixels.length; i += 4) {
                                        mod = i % pixelsRow;
                                        if (i >= topLine && i <= bottomLine && mod >= leftLine && mod <= rightLine) {
                                            if (state === true) {
                                                updatePixelColor(color, texturePixels, textureOriginPixels, alpha, i);
                                            } else {
                                                updatePixelReverse(texturePixels, textureOriginPixels, i);
                                            }
                                        }
                                    }
                                });
                            });
                            textureUpdatedData = textureData;
                        }
                        texture.ctx.putImageData(textureUpdatedData, 0, 0);
                        texture.texture.needsUpdate = true;
                    }
                }

                function bleedTechLinesActive() {
                    return scope.bleedTechLine.is_active !== null || scope.cutTechLine.is_active !== null;
                }

                function resetGeometriesSizes() {
                    var zoomX = !bleedTechLinesActive() ? (scope.pxValue * (scope.fileMMSize - 2 * scope.bleed)) / scope.sizes.width * scope.zoomValue : scope.zoomValue,
                        zoomY = !bleedTechLinesActive() ? (scope.pxValue * (scope.fileGrossHeight - 2 * scope.bleed)) / scope.sizes.height * scope.zoomValue : scope.zoomValue;

                    object.scale.x = zoomX;
                    object.scale.y = zoomY;

                    var width = objectBBox.max.x - objectBBox.min.x;
                    var height = objectBBox.max.y - objectBBox.min.y;

                    var x = -(scope.previewWidth / 2) + (width * zoomX / 2) + scope.spaceFix;
                    var y = (scope.previewHeight / 2) - (height * zoomY / 2) - scope.spaceFix;

                    object.position.x = x;
                    object.position.y = y;
                }

                function fixBleedArea() {
                    var bleedValue = !bleedTechLinesActive() ? scope.bleedInPx : 0;
                    angular.forEach(materials, function (material, index) {
                        var imgWidth, imgHeight;
                        if (scope.isMultiPageFile) {
                            imgWidth = !bleedTechLinesActive() ? material.map.image.width - bleedValue * 2 : material.map.image.width - scope.bleedInPx;
                            imgHeight = material.map.image.height - bleedValue * 2;
                            material.map.repeat.x = imgWidth / material.map.image.width;
                            material.map.repeat.y = imgHeight / material.map.image.height;
                            material.map.offset.x = !bleedTechLinesActive() ? (bleedValue / imgWidth) * material.map.repeat.x : (index % 2 === 0 ? (scope.bleedInPx / imgWidth) * material.map.repeat.x : 0);
                            material.map.offset.y = (bleedValue / imgHeight) * material.map.repeat.y;
                        } else {
                            imgWidth = material.map.image.width - bleedValue * 2;
                            imgHeight = material.map.image.height - bleedValue * 2;
                            material.map.repeat.x = imgWidth / material.map.image.width;
                            material.map.repeat.y = imgHeight / material.map.image.height;
                            material.map.offset.x = (bleedValue / imgWidth) * material.map.repeat.x;
                            material.map.offset.y = (bleedValue / imgHeight) * material.map.repeat.y;
                        }
                        scope.offset = {
                            x: material.map.offset.x,
                            y: material.map.offset.y,
                            rx: material.map.repeat.x,
                            ry: material.map.repeat.y
                        }
                    });
                }
                
                scope.$on('$destroy', function () {
                    angular.forEach(scene.__objects, function (obj) {
                        if (obj !== undefined) {
                            if (obj.geometry) {
                                obj.geometry.dispose();
                            }

                            if (obj.material) {
                                if (obj.material instanceof THREE.MeshFaceMaterial) {
                                    angular.forEach(obj.material.materials, function (obj) {
                                        obj.dispose();
                                    });
                                } else {
                                    obj.material.dispose();
                                }
                            }

                            if (obj.dispose) {
                                obj.dispose();
                            }
                        }
                    });
                    renderer.domElement.remove();
                    container.remove();
                    renderer.dispose();
                    controls.dispose();
                });
                
                function frontCover() {
                    return scope.bookletUv ? scope.orderProductFile.cover_pages.slice(0, 4) : [];
                }
                
                function backCover() {
                    return scope.bookletUv ? scope.orderProductFile.cover_pages.slice(4, 8) : [];
                }

                function frontCoverForExceptions() {
                    var idx = scope.orderProductFile.cover_file_num_pages < 8 ? 3 : 4;
                    return scope.bookletUv ? scope.orderProductFile.cover_pages.slice(0, idx) : [];
                }

                function backCoverForExceptions() {
                    var idx = scope.orderProductFile.cover_file_num_pages < 8 ? 1 : -1,
                        cover = scope.bookletUv ? scope.orderProductFile.cover_pages.slice(4, 8) : [];

                    if (idx > -1) {
                        cover.splice(idx, 1);
                    }

                    return cover
                }

                function rotateObject(angle) {
                    if (renderer && scene && !scope.isMultiPageFile) {
                        object.rotation.y = (angle * (Math.PI / 180));
                        if (!scope.isLastPage() && angle > 90) {
                            scope.changePage(scope.currentPage + 1);
                        } else if (!scope.isFirstPage() && angle <= 90) {
                            scope.changePage(scope.currentPage - 1);
                        }
                        renderer.render(scene, camera);
                    }
                }
            }
        };
    }
})();
